export const registerEventHandlers = () => {};



// WEBPACK FOOTER //
// ./src/main/javascript/Storage/EventHandlers.js